import { render, staticRenderFns } from "./EImage.vue?vue&type=template&id=05064934&scoped=true"
import script from "./EImage.vue?vue&type=script&lang=js"
export * from "./EImage.vue?vue&type=script&lang=js"
import style0 from "./EImage.vue?vue&type=style&index=0&id=05064934&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05064934",
  null
  
)

export default component.exports